module.exports = __webpack_public_path__ + "img/brand1.ebd62c44.png";